import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item active" }
const _hoisted_5 = { "aria-current": "location" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "display-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  class: "col-sm-4 col-form-label text-end",
  for: "trackerQuery"
}
const _hoisted_11 = { class: "col-sm-7" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "card"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\">You can narrow down the results using any the following qualifiers:<br><ul><li><code>tag:mytag</code> or <code>tag:&quot;some tag&quot;</code></li><li><code>is:issue</code> or <code>is:feature</code></li><li><code>is:open</code> or <code>is:closed</code></li><li><code>title:&quot;some text&quot;</code></li><li><code>body:&quot;some text&quot;</code></li></ul>These qualifiers can be combined using the <code>|</code> operator to build a logical expression. Qualifiers separated by a space or a <code>&amp;</code> will be combined with an AND operator.<br><br>Sample queries:<div><code>is:issue tag:linux tag:&quot;area: gameplay&quot;</code>: find gameplay issues related to Linux.</div><div><code>is:feature (tag:duplicate | tag:&quot;area: modding&quot;)</code>: find duplicate or modding-related feature requests</div></div>", 1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary w-100" }, "Submit")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_IfFlag = _resolveComponent("IfFlag")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["TitleTag"], {
      title: $setup.getTickets.data.value?.product.prettyName + ' tracker'
    }, null, 8, ["title"]),
    _createVNode($setup["CanonicalRouteTag"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/tracker" }, {
            default: _withCtx(() => [
              _createTextVNode("Trackers")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.getTickets.data.value?.product.prettyName ?? $props.prod), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, "Tracked tickets in: " + _toDisplayString($setup.getTickets.data.value?.product.prettyName.toLowerCase() || $props.prod), 1),
        _createVNode(_component_IfFlag, {
          flag: `can-create-ticket-${$props.prod}`
        }, {
          default: _withCtx(() => [
            ($setup.authed)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "btn btn-success ms-auto align-self-end mb-3",
                  to: `/tracker/${$props.prod}/new`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Create ticket")
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["flag"])
      ]),
      _hoisted_8,
      _createElementVNode("form", {
        class: "mb-3",
        onSubmit: _withModifiers($setup.updateQuery, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createTextVNode("Advanced query"),
            _createElementVNode("span", {
              class: "badge bg-light mx-1 pointer",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.showExplanation = !$setup.showExplanation))
            }, "?"),
            _createTextVNode(":")
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              id: "trackerQuery",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.queryString) = $event))
            }, null, 512), [
              [_vModelText, $setup.queryString]
            ]),
            ($setup.queryError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Invalid query: " + _toDisplayString($setup.queryError), 1))
              : _createCommentVNode("", true),
            ($setup.showExplanation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _hoisted_16
        ])
      ], 32),
      _createVNode($setup["Pagination"], {
        "fetch-items": $setup.fetchItems,
        "use-route": "use-route",
        "emit-load": "emit-load"
      }, {
        default: _withCtx((slot) => [
          slot
            ? (_openBlock(), _createBlock($setup["Listing"], {
                key: 0,
                ticket: slot.item
              }, null, 8, ["ticket"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}